import { IsOptional, IsNumber, IsBoolean, IsIn } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IWeightPullScore } from "./weight-pull-score.interface";

const WEIGHT_PULL_RESULT_TYPES = [
  Constants.score_result_type.qualified,
  Constants.score_result_type.not_qualified,
  Constants.score_result_type.absent,
];

// -------------------
export class WeightPullScoreDto implements IWeightPullScore {
  //
  @IsOptional()
  @IsIn(WEIGHT_PULL_RESULT_TYPES)
  result_type?: string;

  @IsOptional()
  weight_class?: string;

  @IsOptional()
  @IsNumber()
  dog_weight?: number; //lbs

  @IsOptional()
  weighed_by?: string; // initials of person who weighed the dog

  // results
  @IsOptional()
  @IsNumber()
  highest_weight?: number; //lbs

  @IsOptional()
  @IsNumber()
  percent_pulled?: number; // (highest_weight / dog_weight) * 100

  @IsOptional()
  @IsNumber()
  time?: number; //number of seconds, decimal

  @IsOptional()
  @IsBoolean()
  excluded_from_placement?: boolean;
}
